var _rect, _rect2, _rect3, _g, _rect4, _path, _path2, _path3, _g2, _rect5, _path4, _path5, _path6, _defs, _g3, _defs2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-v-0dd9719b": "",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "100%",
    height: "100%",
    viewBox: "0 0 340.000000 250.000000",
    preserveAspectRatio: "xMidYMid meet",
    colorInterpolationFilters: "sRGB",
    style: {
      margin: "auto"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-v-0dd9719b": "",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "transparent",
    fillOpacity: 1,
    className: "background"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    "data-v-0dd9719b": "",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "url(#watermark)",
    fillOpacity: 1,
    className: "watermarklayer"
  })), /*#__PURE__*/React.createElement("g", {
    "data-v-0dd9719b": "",
    fill: "#1d0a5b",
    className: "icon-text-wrapper icon-svg-group iconsvg",
    transform: "translate(53,8)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#1d0a5b",
    className: "iconsvg-imagesvg icon_container",
    transform: "translate(0,0)"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#1d0a5b",
    fillOpacity: 0,
    strokeWidth: 2,
    x: 0,
    y: 0,
    width: 233.99999999999991,
    height: 233.99999999999991,
    className: "image-rect"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 40.240369138319565",
    x: 0,
    y: 0,
    width: 233.99999999999991,
    height: 233.99999999999991,
    className: "image-svg-svg bn",
    style: {
      overflow: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "hollow-target": "iconBnFill",
    mask: "url(#856786ff-ede7-41f5-bf2c-db7e4da847b8)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-0.00528 0.00219 158.59898 106.3678",
    style: {
      overflow: "visible"
    },
    width: 60,
    height: 40.240369138319565,
    x: 0,
    y: 0,
    filtersec: "colorsf6817368923",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(1, 1) skewX(0)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a4301d559-6600-4ef0-8dca-afdbb08bd3aa",
    x1: 79.3,
    y1: 94.29,
    x2: 79.3,
    y2: 0.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8fdcdc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#be9aff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b0c347978-b78d-4255-8e40-e9a3a7976c76",
    x1: -27.48,
    y1: 97.11,
    x2: 121.52,
    y2: 50.07,
    gradientTransform: "rotate(17.52 130.686 171.631)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#be9aff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8fdcdc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c28570789-5f79-4312-9ad4-da578c2d2220",
    x1: 28.95,
    y1: 95.13,
    x2: 51.43,
    y2: 95.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#be9aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#8fdcdc"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M3.28 77.84c-14-24.61 19.63-60 46.49-71C79.48-5.27 133.1-1.34 152.55 38.5c9.18 18.8 16 60.88-43.22 52.34-58.67-8.45-87.22 20.16-106.05-13z",
    fill: "#F8D57C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.73 59.93c-5-30.4 32.68-58.29 63.69-59.8 42.06-2 78.71 19.46 90.82 65.3 6.64 25.17-11.46 56.92-70.69 30.57C32.37 71.88 6.5 83 2.73 59.93z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.19,
    cy: 95.13,
    r: 11.24,
    fill: "white"
  }))))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#colors2776433431)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 9.600000000000001,
    y: 6.438460469159782,
    viewBox: "5.186999797821045 21.37200164794922 90 61.525001525878906",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    width: 40.8,
    height: 27.3634482,
    className: "image-svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5.187,
    y: 80.396,
    width: 90,
    height: 2.501
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.052,36.161h0.817v2.312h-0.817v40.739h23.45V48.695V38.473H72.81v-2.312h0.692v-1.106h-23.45V36.161z M70.162,72.46  h-1.106V45.126h1.106V72.46z M70.532,36.161h1.035h0.21v2.312h-3.202v-2.312H70.532z M66.296,36.161h1.035h0.21v2.312h-3.201v-2.312  H66.296z M62.061,36.161h1.035h0.21v2.312h-3.202v-2.312H62.061z M57.825,36.161h1.035h0.21v2.312h-3.202v-2.312H57.825z   M53.588,36.161h1.035h0.21v2.312h-2.929v-2.312H53.588z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.273,22.478h0.651v-1.106H14.746v1.106h0.764v2.59h-0.788v7.788H7.045v1.106h1.35v45.249h1.106V66.996l4.146,6.177  l-4.052,6.039h1.331l3.796-5.655v5.655h34.224V37.92V25.068h-0.674V22.478z M13.443,33.963l-3.942,5.866v-5.866H13.443z   M9.501,40.657l4.146,6.17l-4.146,6.171V40.657z M9.501,53.827l4.146,6.168l-4.146,6.173V53.827z M14.722,72.79l-4.167-6.208  l4.167-6.204V72.79z M14.722,59.612l-4.167-6.199l4.167-6.202V59.612z M14.722,46.444l-4.167-6.201l4.167-6.2V46.444z   M47.205,25.068h-4.214v-2.59h4.214V25.068z M41.923,25.068h-4.215v-2.59h4.215V25.068z M36.64,25.068h-4.214v-2.59h4.214V25.068z   M31.358,25.068h-4.215v-2.59h4.215V25.068z M26.075,25.068h-4.214v-2.59h4.214V25.068z M16.578,22.478h4.215v2.59h-4.215V22.478z   M44.712,73.291h-1.106v-8.609h1.106V73.291z M44.712,62.412h-1.106V40.414h1.106V62.412z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.546,47.151v-1.106H74.609v1.106h0.52v2.096h-0.52v29.964h17.937V49.248h-0.653v-2.096H92.546z M85.751,47.151h0.975  h0.198v2.096h-3.017v-2.096H85.751z M81.759,47.151h0.975h0.198v2.096h-3.018v-2.096H81.759z M76.104,47.151h1.661h0.975h0.198  v2.096h-2.834V47.151z M89.769,73.338h-1.106V56.531h1.106V73.338z M90.918,49.248h-3.018v-2.096h1.845h0.975h0.198V49.248z"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "856786ff-ede7-41f5-bf2c-db7e4da847b8"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-0.00528 0.00219 158.59898 106.3678",
    style: {
      overflow: "visible"
    },
    width: 60,
    height: 40.240369138319565,
    x: 0,
    y: 0,
    filtersec: "colorsf6817368923",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "scale(1, 1) skewX(0)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a4301d559-6600-4ef0-8dca-afdbb08bd3aa",
    x1: 79.3,
    y1: 94.29,
    x2: 79.3,
    y2: 0.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8fdcdc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#be9aff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b0c347978-b78d-4255-8e40-e9a3a7976c76",
    x1: -27.48,
    y1: 97.11,
    x2: 121.52,
    y2: 50.07,
    gradientTransform: "rotate(17.52 130.686 171.631)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#be9aff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8fdcdc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c28570789-5f79-4312-9ad4-da578c2d2220",
    x1: 28.95,
    y1: 95.13,
    x2: 51.43,
    y2: 95.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#be9aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#8fdcdc"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M3.28 77.84c-14-24.61 19.63-60 46.49-71C79.48-5.27 133.1-1.34 152.55 38.5c9.18 18.8 16 60.88-43.22 52.34-58.67-8.45-87.22 20.16-106.05-13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.73 59.93c-5-30.4 32.68-58.29 63.69-59.8 42.06-2 78.71 19.46 90.82 65.3 6.64 25.17-11.46 56.92-70.69 30.57C32.37 71.88 6.5 83 2.73 59.93z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.19,
    cy: 95.13,
    r: 11.24
  }))))), /*#__PURE__*/React.createElement("g", {
    fill: "black"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 9.600000000000001,
    y: 6.438460469159782,
    viewBox: "5.186999797821045 21.37200164794922 90 61.525001525878906",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    width: 40.8,
    height: 27.3634482,
    className: "image-svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 5.187,
    y: 80.396,
    width: 90,
    height: 2.501
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.052,36.161h0.817v2.312h-0.817v40.739h23.45V48.695V38.473H72.81v-2.312h0.692v-1.106h-23.45V36.161z M70.162,72.46  h-1.106V45.126h1.106V72.46z M70.532,36.161h1.035h0.21v2.312h-3.202v-2.312H70.532z M66.296,36.161h1.035h0.21v2.312h-3.201v-2.312  H66.296z M62.061,36.161h1.035h0.21v2.312h-3.202v-2.312H62.061z M57.825,36.161h1.035h0.21v2.312h-3.202v-2.312H57.825z   M53.588,36.161h1.035h0.21v2.312h-2.929v-2.312H53.588z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.273,22.478h0.651v-1.106H14.746v1.106h0.764v2.59h-0.788v7.788H7.045v1.106h1.35v45.249h1.106V66.996l4.146,6.177  l-4.052,6.039h1.331l3.796-5.655v5.655h34.224V37.92V25.068h-0.674V22.478z M13.443,33.963l-3.942,5.866v-5.866H13.443z   M9.501,40.657l4.146,6.17l-4.146,6.171V40.657z M9.501,53.827l4.146,6.168l-4.146,6.173V53.827z M14.722,72.79l-4.167-6.208  l4.167-6.204V72.79z M14.722,59.612l-4.167-6.199l4.167-6.202V59.612z M14.722,46.444l-4.167-6.201l4.167-6.2V46.444z   M47.205,25.068h-4.214v-2.59h4.214V25.068z M41.923,25.068h-4.215v-2.59h4.215V25.068z M36.64,25.068h-4.214v-2.59h4.214V25.068z   M31.358,25.068h-4.215v-2.59h4.215V25.068z M26.075,25.068h-4.214v-2.59h4.214V25.068z M16.578,22.478h4.215v2.59h-4.215V22.478z   M44.712,73.291h-1.106v-8.609h1.106V73.291z M44.712,62.412h-1.106V40.414h1.106V62.412z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M92.546,47.151v-1.106H74.609v1.106h0.52v2.096h-0.52v29.964h17.937V49.248h-0.653v-2.096H92.546z M85.751,47.151h0.975  h0.198v2.096h-3.017v-2.096H85.751z M81.759,47.151h0.975h0.198v2.096h-3.018v-2.096H81.759z M76.104,47.151h1.661h0.975h0.198  v2.096h-2.834V47.151z M89.769,73.338h-1.106V56.531h1.106V73.338z M90.918,49.248h-3.018v-2.096h1.845h0.975h0.198V49.248z"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "colors2776433431"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.11328125  0 0 0 0 0.0390625  0 0 0 0 0.35546875  0 0 0 1 0",
    className: "icon-fecolormatrix"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "colorsf6817368923"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.99609375  0 0 0 0 0.99609375  0 0 0 0 0.99609375  0 0 0 1 0",
    className: "icon-fecolormatrix"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "colorsb4335426722"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 1 0",
    className: "icon-fecolormatrix"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(117,240)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-gra": "path-name",
    fillRule: "",
    className: "tp-name iconsvg-namesvg"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "",
    transform: "translate(0, 0)"
  }))))))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", {
    "v-gra": "od"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTank);
export default __webpack_public_path__ + "static/media/tank.24dd0f164f2799629f9238031881727e.svg";
export { ForwardRef as ReactComponent };